import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './index.scss';
import {
    NavigationBar,
    IconChevronLeftRegular,
    Text2,
    ThemeVariant,
    NavigationBarAction,
    NavigationBarActionGroup,
    IconInformationUserRegular,
    skinVars,
} from '@telefonica/mistica';
import { t } from 'i18next';
import { createPortal } from 'react-dom';
import ModalTestFiber from '../../../../components/ModalPortalTestFiber';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import BreadCrumbsWrapper from '../../../../components/BreadcrumbsWrapper';
const FiberTestIFrame: React.FC = () => {
    const navigate = useNavigate();
    let [modal, setModal] = useState<boolean>(false);
    const openModal = () => setModal(true);
    const closeModal = () => setModal(false);
    const { trackingScreenView } = new TrackingEvents();

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    return (
        <>
            <div className='fiber-test-velocity'>
                <div className='fiber-test-velocity__header' style={{ background: skinVars.colors.backgroundBrand }}>
                    {!(isWebviewAndroid || isWebviewIOS) && (
                        <>
                            <div className='fiber-test-velocity__header-navigationBar'>
                                <NavigationBar
                                    isInverse={true}
                                    onBack={() => {
                                        navigate(-1);
                                    }}
                                    title={t('speedTestFiber')}
                                    right={
                                        <NavigationBarActionGroup>
                                            <NavigationBarAction aria-label='info' onPress={openModal}>
                                                <IconInformationUserRegular size={24} />
                                            </NavigationBarAction>
                                        </NavigationBarActionGroup>
                                    }
                                />
                            </div>
                            <div
                                className='fiber-test-velocity__header-return'
                                onClick={() => {
                                    navigate(-1);
                                }}
                            >
                                <div className='fiber-test-velocity__header-return-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.appBarBackground}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </>
                    )}
                    <div className='fiber-test-velocity__header-breadcrumbs'>
                        <ThemeVariant isInverse>
                            <BreadCrumbsWrapper
                                title={t('speedTestFiber')}
                                breadcrumbs={[
                                    { title: t('breadcrumbsHome'), url: '/home' },
                                    { title: t('fiber'), url: '/fiber' },
                                ]}
                            />
                        </ThemeVariant>
                        <div onClick={openModal} className='fiber-test-velocity__header-breadcrumbs-icon'>
                            <IconInformationUserRegular color={skinVars.colors.appBarBackground} size={24} />
                        </div>
                    </div>
                </div>
                <div className='fiber-test-velocity__iframe'>
                    <iframe scrolling='yes' src='https://www.movispeed.es/o2/'></iframe>
                </div>
            </div>
            {modal && createPortal(<ModalTestFiber onClose={() => closeModal()} />, document.body)}
        </>
    );
};

export default FiberTestIFrame;
